import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;
  
  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.dataNascimento);
  }
  if (solicitacao.dataVigenciaInicio) {
    solicitacao.dataVigenciaInicio = await formatarData.paraNumero(solicitacao.dataVigenciaInicio);
  }
  if (solicitacao.dataVigenciaFim) {
    solicitacao.dataVigenciaFim = await formatarData.paraNumero(solicitacao.dataVigenciaFim);
  }

  if (solicitacao.dataTermoAditivoTa) {
    solicitacao.dataTermoAditivoTa = await formatarData.paraNumero(solicitacao.dataTermoAditivoTa);
  }

  if (solicitacao.dataVigenciaInicioTa) {
    solicitacao.dataVigenciaInicioTa = await formatarData.paraNumero(solicitacao.dataVigenciaInicioTa);
  }

  if (solicitacao.dataVigenciaTerminoTa) {
    solicitacao.dataVigenciaTerminoTa = await formatarData.paraNumero(solicitacao.dataVigenciaTerminoTa);
  }

  if (solicitacao.tipoValor == "1")
    solicitacao.tipoValor = 1;

  if (solicitacao.tipoValor == "2")
    solicitacao.tipoValor = 2;

  if (solicitacao.tipoPrazo == "1")
    solicitacao.tipoPrazo = 1;

  if (solicitacao.tipoPrazo == "2")
    solicitacao.tipoPrazo = 2;
    
  if (solicitacao.funcionarioPublico == 1)
    solicitacao.funcionarioPublico = true;

  if (solicitacao.funcionarioPublico == 0)
    solicitacao.funcionarioPublico = false;

  if (solicitacao.pertenceQuadroUSP == 1)
    solicitacao.pertenceQuadroUSP = true;

  if (solicitacao.pertenceQuadroUSP == 0)
    solicitacao.pertenceQuadroUSP = false;

  if (solicitacao.solicitacaoAnexouArquivo != null) {
    solicitacao.solicitacaoAnexouArquivo = solicitacao.solicitacaoAnexouArquivo == 1 ? true : false;
  }

  return solicitacao;
}

function normalizarParaVisualizar(solicitacao) {
  solicitacao.valorContrato = converterMoeda.paraReal(solicitacao.valorContrato);

  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = formatarData.paraData(solicitacao.dataNascimento);
  }
  if (solicitacao.dataVigenciaInicio) {
    solicitacao.dataVigenciaInicio = formatarData.paraData(solicitacao.dataVigenciaInicio);
  }
  if (solicitacao.dataVigenciaFim) {
    solicitacao.dataVigenciaFim = formatarData.paraData(solicitacao.dataVigenciaFim);
  }

  if (solicitacao.dataTermoAditivoTa) {
    solicitacao.dataTermoAditivoTa = formatarData.paraData(solicitacao.dataTermoAditivoTa);
  }

  if (solicitacao.dataVigenciaInicioTa) {
    solicitacao.dataVigenciaInicioTa = formatarData.paraData(solicitacao.dataVigenciaInicioTa);
  }

  if (solicitacao.dataVigenciaTerminoTa) {
    solicitacao.dataVigenciaTerminoTa = formatarData.paraData(solicitacao.dataVigenciaTerminoTa);
  }

  if (solicitacao.inss) {
    solicitacao.inss = solicitacao.inss.replace('   .     .  / ', "");
  }

  if (solicitacao.pispasep) {
    solicitacao.pispasep = solicitacao.pispasep.replace('   .     .  / ', "");
  }

  if (solicitacao.tipoValor == 1)
    solicitacao.tipoValor = "1";

  if (solicitacao.tipoValor == 2)
    solicitacao.tipoValor = "2";

  if (solicitacao.tipoPrazo == 1)
    solicitacao.tipoPrazo = "1";

  if (solicitacao.tipoPrazo == 2)
    solicitacao.tipoPrazo = "2";

  if (solicitacao.funcionarioPublico != null) {
    if (solicitacao.funcionarioPublico == true)
      solicitacao.funcionarioPublico = 1;

    if (solicitacao.funcionarioPublico == false)
      solicitacao.funcionarioPublico = 0;
  }

  if (solicitacao.pertenceQuadroUSP != null) {
    if (solicitacao.pertenceQuadroUSP == true)
      solicitacao.pertenceQuadroUSP = 1;

    if (solicitacao.pertenceQuadroUSP == false)
      solicitacao.pertenceQuadroUSP = 0;
  }

  if (solicitacao.solicitacaoAnexouArquivo != null) {
    solicitacao.solicitacaoAnexouArquivo = solicitacao.solicitacaoAnexouArquivo ? 'true' : 'false';
  }

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaobolsas', { params: parametros });
  },
  adicionar: async (solicitacao, solicitacaoBolsaArquivo, arquivos) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;
    solicitacao.solicitacaoBolsaArquivo = solicitacaoBolsaArquivo;
    solicitacao = await converterObjetoFormData(solicitacao);
    return Vue.http.post('/api/solicitacaobolsas', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, solicitacaoBolsaArquivo, arquivos, id) => {
    solicitacao = await normalizarParaSalvar(solicitacao, id);
    solicitacao.arquivos = arquivos;
    solicitacao.solicitacaoBolsaArquivo = solicitacaoBolsaArquivo;
    solicitacao = await converterObjetoFormData(solicitacao);
    return Vue.http.put(`/api/solicitacaobolsas/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaobolsas/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaobolsas/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaobolsas/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaobolsas/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaobolsas/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaobolsas/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  contratosTermoAditivo: (id, cpfCnpj) => {
    return Vue.http.get(`/api/solicitacaobolsas/${id}/${cpfCnpj}/contratostermoaditivo`).then(resposta => resposta.body);
  },

  //Parâmetro 2 devido ao código do módulo bolsa descrito no arquivo Notificacao.vue
  carregarTipoArquivo: function () {
    return Vue.http.get(`/api/SolicitacaoTipoArquivo/tipoarquivo/2`)
      .then(response => response.data)  
  },

  carregarSolicitacaoBolsaArquivo: (idSolicitacaoBolsa) => {
    return Vue.http.get(`/api/SolicitacaoBolsaArquivo/listar/${idSolicitacaoBolsa}`)
      .then(response => response.data)
  },

  downloadBolsaArquivo: (id, arquivo) => {
    return Vue.http.get(`/api/SolicitacaoBolsaArquivo/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-bolsa/servico.js